'use client';

import ArrowMinimal from '@/assets/svg/ArrowMinimal';
import ArrowSharpMinimal from '@/assets/svg/ArrowSharpMinimal';
import { cn } from '@/lib/utils';
import { a, useSpring } from '@react-spring/web';
import { PropsWithChildren, useState } from 'react';
import useMeasure from 'react-use-measure';

interface Props {
  title: string;
  description?: string;
  className?: string;
  offset?: number;
}

export default function ({ title, description, className, offset }: Props) {
  const [opened, setOpened] = useState(false);
  const [ref, { height }] = useMeasure();

  const elementStyle = useSpring({
    height: !opened ? 0 : height,
    opacity: !opened ? 0 : 1,
  });

  const arrowStyle = useSpring({
    rotate: opened ? 180 : 0,
  });

  return (
    <div
      className={cn('border-b py-5 sm:!pl-0 border-[#0D1524]', className)}
      onClick={() => !!description && setOpened(!opened)}
    >
      <div className='flex justify-between items-end w-full pl-8'>
        <p className='2xl:text-[30px] text-[20px] sm:text-[20px] sm:align-middle'>
          {title}
        </p>
        {description && (
          <a.div style={arrowStyle} className={cn('w-4 h-4')}>
            <ArrowSharpMinimal className='fill-[#0D1524]' />
          </a.div>
        )}
      </div>
      {description && (
        <a.div
          style={elementStyle}
          className={cn({
            'pointer-events-none': !opened,
          })}
        >
          <div ref={ref}>
            <p className='font-poppins 2xl:text-[20px] text-[13px] pt-5 leading-[120%] pl-8'>
              {description}
            </p>
          </div>
        </a.div>
      )}
    </div>
  );
}
